import React, { Component, createRef, Fragment } from "react";
import { disablePageScroll, enablePageScroll } from "scroll-lock";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import ButtonBurger from "../UI/ButtonBurger/ButtonBurger";
import ROUTES from "../../constants/routes";
import Icon from "../UI/Icon/Icon";
import { logout } from "../../store/actions/authActions";
import ROLES from "../../constants/roles";
import Swal from "sweetalert2";

import "./Sidebar.sass";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);
class Sidebar extends Component {
  state = {
    isSidebarState: true,
  };
  modalRef = createRef(null);

  toggleSidebar = (isSidebarState) => this.setState({ isSidebarState });
  logoutEvent = () => {
    MySwal.fire({
      title: "Are you sure you want to log out?",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      showConfirmButton: true,
      confirmButtonText: "Log out",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.props.logout();
      }
    });
  };

  isLinkActive = (match, location, typeOfRoute) => {
    const routeNormalizer = (route) => route.split("/")[1];
    if (typeOfRoute === ROUTES.EVENTS) {
      return (
        match ||
        routeNormalizer(location.pathname) === routeNormalizer(ROUTES.EVENT) ||
        location.pathname === ROUTES.ADD_EVENT ||
        routeNormalizer(location.pathname) ===
          routeNormalizer(ROUTES.ADD_TICKET)
      );
    } else if (typeOfRoute === ROUTES.SCANTEAMS) {
      return (
        match ||
        routeNormalizer(location.pathname) ===
          routeNormalizer(ROUTES.SCANTEAMS_VIEW)
      );
    }
  };

  componentDidUpdate() {
    if (!this.state.isSidebarState) {
      disablePageScroll(this.modalRef.current);
    } else {
      enablePageScroll(this.modalRef.current);
    }
  }

  render() {
    const { isSidebarState } = this.state;
    const {
      auth: {
        user: { role },
      },
    } = this.props;
    const userCopy = JSON.parse(localStorage.getItem("userCopy"));

    let navigation = null;

    if (
      role === ROLES.PROMOTER &&
      window.location.pathname !== ROUTES.PROMOTERS
    ) {
      navigation = (
        <Fragment>
          <NavLink
            className="sidebar-item events"
            to={ROUTES.EVENTS}
            onClick={this.toggleSidebar}
            isActive={(match, location) =>
              this.isLinkActive(match, location, ROUTES.EVENTS)
            }
          >
            <Icon name="events" />
            <span>Events</span>
          </NavLink>
          <NavLink
            className="sidebar-item groups"
            to={ROUTES.SCANTEAMS}
            onClick={this.toggleSidebar}
            isActive={(match, location) =>
              this.isLinkActive(match, location, ROUTES.SCANTEAMS)
            }
          >
            <Icon name="groups" />
            <span>Teams</span>
          </NavLink>
          <NavLink
            className="sidebar-item payment"
            to={ROUTES.PAYMENTS}
            onClick={this.toggleSidebar}
          >
            <Icon name="payment" />
            <span>Payment</span>
          </NavLink>
          <NavLink
            className="sidebar-item payment"
            to={ROUTES.DASHBOARD}
            onClick={this.toggleSidebar}
          >
            <Icon name="dashboard-stats" />
            <span>Dashboard</span>
          </NavLink>
          {/* <NavLink className="sidebar-item faq" to={ROUTES.FAQ} onClick={this.toggleSidebar}>
                        <Icon name="faq"/>
                        <span>FAQ</span>
                    </NavLink> */}
        </Fragment>
      );
    } else if (
      role === ROLES.ADMIN ||
      (userCopy && userCopy.role === ROLES.ADMIN)
    ) {
      navigation = (
        <NavLink
          className="sidebar-item groups"
          to={ROUTES.PROMOTERS}
          onClick={this.toggleSidebar}
        >
          <Icon name="groups" />
          <span>Promoters</span>
        </NavLink>
      );
    }

    return (
      <div
        className={isSidebarState ? "sidebar minimized" : "sidebar"}
        ref={this.modalRef}
      >
        <ButtonBurger toggleSidebar={this.toggleSidebar} />
        <div className="sidebar__items-wrapper">
          {navigation}
          {/*TODO: need for future development*/}
          {/*<NavLink className="sidebar-item settings" to="/s"  onClick={this.toggleSidebar}>*/}
          {/*<Icon name="settings"/>*/}
          {/*<span>Settings</span>*/}
          {/*</NavLink>*/}
          <div className="sidebar-item logout" onClick={this.logoutEvent}>
            <Icon name="logout" />
            <span>Log out</span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ auth });

const mapDispatchToProps = (dispatch) => ({
  logout: () => {
    dispatch(logout());
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Sidebar)
);
